import { render, staticRenderFns } from "./AdminProductBulkCat.vue?vue&type=template&id=5ce7fdc8&scoped=true"
import script from "./AdminProductBulkCat.vue?vue&type=script&lang=js"
export * from "./AdminProductBulkCat.vue?vue&type=script&lang=js"
import style0 from "./AdminProductBulkCat.vue?vue&type=style&index=0&id=5ce7fdc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8be560a05ba39e4779a4b3800f88bf1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce7fdc8",
  null
  
)

export default component.exports